var React = require('react');

function Home (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Chickpea"},React.createElement("path",{"d":"M458.74,338.85c-6.42,20.81-13.61,38.43-28.05,54.46-5.6,6.4-28.02,28.04-37.63,18.44-1.62-1.59-3.21-8.01-4.01-10.4.8-.8-8.81-36.06-18.44-61.69-13.62-34.46-37.63-64.08-74.49-88.94-6.4-3.99-14.41-7.97-20.81-3.99-8.81,5.62-7.21,19.23-1.61,27.25,28.05,42.42,47.26,75.29,43.25,141.76-1.6,28.82-4.01,52.88-36.04,57.66-30.44,4.82-60.88,4.03-90.51-3.19-57.66-13.61-110.53-50.45-137.77-103.33-26.43-52.08-24.82-111.34-4.8-164.2,20.83-54.48,64.88-93.72,79.29-151.37,1.62-7.23,1.62-20.83,8.01-25.65,5.62-3.99,13.61-1.59,20.03,1.6,18.42,11.24,44.85,17.62,65.68,23.26,48.85,13.59,100.92,17.62,144.97,44.05,37.65,22.4,65.68,58.46,82.5,99.3,19.23,45.65,25.63,97.73,10.42,144.99"})));
}

Home.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 500 500"};

module.exports = Home;

Home.default = Home;
